import React from 'react';
import {View} from 'react-native';

import FontAwesome from 'react-native-vector-icons/FontAwesome';

const Stars = ({
  rating = 0,
  size = 20,
  color = global?.color?.yellow,
  containerStyle = {},
}) => {
  const ratingArray = new Array(Math.max(rating * 1, 1)).fill(0);
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        ...containerStyle,
      }}>
      {ratingArray?.map?.((item, index) => {
        return (
          <FontAwesome
            color={color}
            size={size}
            style={{margin: 2}}
            key={index}
            name={'star'}
          />
        );
      })}
    </View>
  );
};

export default Stars;
